import { Controller } from "stimulus"

// Ticket 975: in- en uitklapbare zijbalk. De keuze wordt per apparaat
// onthouden in localStorage, zodat het menu bij een volgend bezoek weer
// in dezelfde stand staat.
export default class extends Controller {
  static targets = ["panel", "expander"]

  connect() {
    if (localStorage.getItem("cc_sidebar") === "collapsed") {
      this.collapse()
    }
  }

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  collapse() {
    this.panelTarget.classList.add("hidden")
    this.expanderTarget.classList.remove("hidden")
    this.expanderTarget.classList.add("flex")
    localStorage.setItem("cc_sidebar", "collapsed")
  }

  expand() {
    this.panelTarget.classList.remove("hidden")
    this.expanderTarget.classList.add("hidden")
    this.expanderTarget.classList.remove("flex")
    localStorage.setItem("cc_sidebar", "open")
  }
}
